import { useState } from 'react';

import { Box } from '@mui/material';

export type AdaptiveOrganisationLogoProps = {
  src?: string | null;
  name?: string;
  height: number;
  minWidth?: number;
  maxWidth?: number;
};

const AdaptiveOrganisationLogo = ({
  src,
  name = '',
  height,
  minWidth = 24,
  maxWidth = 120,
}: AdaptiveOrganisationLogoProps) => {
  const [ratio, setRatio] = useState(1);
  const boxWidth = Math.min(Math.max(height * ratio, minWidth), maxWidth);
  const initial = name.trim().charAt(0).toUpperCase() || '?';

  if (!src) {
    return (
      <Box
        sx={{
          width: height,
          height,
          flexShrink: 0,
          borderRadius: '8%',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          typography: 'subtitle2',
        }}
      >
        {initial}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: boxWidth,
        height,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={src}
        alt={name}
        onLoad={(e) => {
          const img = e.currentTarget;
          setRatio(img.naturalWidth / img.naturalHeight);
        }}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default AdaptiveOrganisationLogo;
